export enum LoginErrorCode {
  InvalidRole = 'invalid role',
  InvalidCredentials = 'invalid credentials',
  UserDisabled = 'user disabled',
  OutdatedTermsConsent = 'outdated terms consent',
}
